__turbopack_context__.v({
  "className": "ppgoshasans_76a27d89-module__AU4dqW__className",
  "variable": "ppgoshasans_76a27d89-module__AU4dqW__variable",
});
